import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "design-system-toast-container" */ './LazyToastContainer'),
  loading: () => null,
});
